


import {debug} from "util";

import {TextControlOptions} from "./TextControl.Options";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {LinkControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/LinkControl.Options";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {FontFamilyProperty} from "InternalShared/PageBuilder/Controls/Properties/FontFamilyProperty";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";




declare let rednaoPDFInvoiceParams:any;
export class LinkControl extends PDFControlBase{


    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this),
                new GroupProperties('Link Styles')
                    .AddProperties([
                        new FontFamilyProperty(this,'font-family',this.StyleManager.CreateStyleClassManager('a')).SetLabel('Font Family'),
                        new NumberProperty(this,'font-size',this.StyleManager.CreateStyleClassManager('a')).SetLabel('Font Size').SetPlaceholder('Default'),
                        new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('a')).SetLabel('Font Color')])

            ];
    }
    public AllowedResizeDirection:AllowedResizeDirection="horizontal";
    public Options:LinkControlOptions;
    private properties:GroupProperties[];



    public InternalInitialize() {

    }


    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:''};
    }

    protected InternalGenerateHtml($container: JQuery) {
        let link:HTMLLinkElement=document.createElement('a') as any;
        link.innerText=this.Options.Text;
        link.href=this.Options.URL;
        link.addEventListener('click',e=>{e.preventDefault()});
        $container.append(link);
    }

    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {
            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new SimpleTextProperty(this,'Text').SetLabel('Text').Focus(),
                    new SimpleTextProperty(this,'URL').SetLabel('URL').Focus()
                ])];
        }

        return this.properties;
    }


    public AfterRefresh() {
        let height:number=this.$element.find('.elementContent').height();
        this.$element.velocity('stop',true);
        this.$element.velocity(200,"easeInExp");

    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new LinkControlOptions().Merge());
        });
    }

    protected InternalGetLabel() {
        return 'Link';
    }
}
